module.exports = __webpack_public_path__ + "static/hero-present-intro-mobile-5d4447c5cb07b965f4ef1c9144ad6e7a.mp4";